import handlebars from "handlebars";

handlebars.registerHelper("assign", function (varName, varValue, options) {
  if (!options.data.root) {
    options.data.root = {};
  }
  options.data.root[varName] = varValue;
});

handlebars.registerHelper("increment", function (value) {
  return parseInt(value) + 1;
});

handlebars.registerHelper("decrement", function (value) {
  return parseInt(value) - 1;
});

handlebars.registerHelper("for", function (from, to, incr, block) {
  var accum = "";
  for (var i = from; i < to; i += incr) accum += block.fn(i);
  return accum;
});

handlebars.registerHelper("ifEquals", function (arg1, arg2, options) {
  return arg1 == arg2 ? options.fn(this) : options.inverse(this);
});

handlebars.registerHelper('ifGreaterThan', function (arg1, arg2, options) {
  return arg1 > arg2 ? options.fn(this) : options.inverse(this);
});

handlebars.registerHelper('ifLowerThan', function (arg1, arg2, options) {
  return arg1 < arg2 ? options.fn(this) : options.inverse(this);
});

handlebars.registerHelper("ifNotEquals", function (arg1, arg2, options) {
  return arg1 != arg2 ? options.fn(this) : options.inverse(this);
});

handlebars.registerHelper("getSliderRange", function (arg1) {
  return arg1.length - 1;
});

handlebars.registerHelper("getSliderRangeMiddle", function (arg1) {
  return (arg1.length - 1) / 2;
});

handlebars.registerHelper("math", function (lvalue, operator, rvalue) {
  lvalue = parseFloat(lvalue);
  rvalue = parseFloat(rvalue);

  return {
    "+": lvalue + rvalue,
    "-": lvalue - rvalue,
    "*": lvalue * rvalue,
    "/": lvalue / rvalue,
    "%": lvalue % rvalue,
  }[operator];
});

handlebars.registerHelper("baloon", function (textArg) {
  function replace(text, counter = 1) {
    const posStart = text.search("\\[\\[");
    const posEnd = text.search("\\]\\]");
    if (posStart == -1 || posEnd == -1) return text;

    function extractContent(s) {
      var span = document.createElement("span");
      span.innerHTML = s;
      return span.textContent || span.innerText;
    }
    const baloonTextAndLabel = text
      .slice(posStart + 2, posEnd + 2)
      .replace("]]", "");

    const [baloonText, baloonLabel] =
      extractContent(baloonTextAndLabel).split(":");
    if (!baloonLabel) return baloonText;

    const baloonStr = `<span class="baloon" data-id="${counter}" data-label="${baloonLabel}">${baloonText}</span>`;
    const res = text.slice(0, posStart) + baloonStr + text.slice(posEnd + 2);
    counter++;
    return replace(res, counter);
  }

  return replace(textArg);
});

export const compile = (htmlTemplate, data) => {
  const template = handlebars.compile(htmlTemplate);
  return template(data);
};
